'use strict';

namespace Search {

    interface AutoSearchParams {
        type:string;
        id: string;
    }

    class AutoSearch {
        requestModel: UnifiedSearchModel;
        requestParams: any;
        href:string;

        constructor(private basketService, private unifiedSearchService, private destinationService,
            private searchQueryString, private urlUtils, private $scope, private resourceService) {}

        search($event) {
            if($event) { $event.preventDefault(); }
            if( this.href && this.href.length > 0 ) {

                let index = this.href.indexOf('?');

                if( index > 0 ) {
                    this.$scope.$emit('block', {
                        title: this.resourceService.get('SEARCHINGHOTELS'),
                        subtitle: this.resourceService.get('THISMAYTAKE'),
                        loadingScreenStyle: 'default-searchUnitCtrl'
                    });
                    this.href = this.href.slice(index+1);
                    let queryParams:AutoSearchParams = { type : '0', id: '0' };

                    queryParams = this.urlUtils.splitQs( this.href || '');

                    if ( parseInt(queryParams.type,10)>=0 && parseInt(queryParams.id,10)>=0 ) {

                        this.destinationService.enhanceLegacyDestination({
                            LegacyType : queryParams.type ,
                            LegacyId: queryParams.id
                        })
                        .then(this.destinationService.getDetails)
                        .then(dest => {
                            this.requestModel = this.unifiedSearchService.getDefaultModel();

                            this.searchQueryString.getQueryStringValues(queryParams).then(
                                queryStringValues => {

                                this.requestParams = queryStringValues;
                                this.requestParams.destination = [dest];
                                this.unifiedSearchService.populateSearchUnitService(this.requestParams);
                                this.basketService.startWorkflow( this.basketService.autoSearch,
                                    this.requestParams);

                            });

                        });
                    }
                }
            }
        };
    }

    angular
        .module('core')
        .directive('autoSearch', (): ng.IDirective => {
            return {
                replace: true,
                restrict: 'A',
                transclude: true,
                scope: {},
                bindToController: {
                    href: '@'
                },
                controller: AutoSearch,
                controllerAs: 'autosearch',
                template: '<div ng-click="autosearch.search($event)" ng-transclude></div>'
            };
        });

}
